import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoPersonCircleOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import { jwtDecode } from 'jwt-decode';
import '../../styles.css';
import ContactUsModal from '../ContactUsModal';

const ClientNavBar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [username, setUsername] = useState('Client');

  // Function to open the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSubject('');
    setDescription('');
  };

  // Decode the token from localStorage and extract the first name
  useEffect(() => {
    const token = localStorage.getItem('business_token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const userData = JSON.parse(decoded.sub);
        const firstName = userData.username.split(' ')[0];
        setUsername(firstName);
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  // Simulated send email function
  const sendEmail = () => {
    alert(`Subject: ${subject}\nDescription: ${description}`);
    closeModal();
  };

  return (
    <>
      <nav className="bg-white fixed w-full top-0 left-0 z-10 shadow-md">
        <div className="w-full px-4 py-2 flex justify-between items-center">
          <div className="text-3xl md:text-4xl font-bold">
            <Link
              to="/"
              className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 text-xl md:text-2xl font-bold hover:text-indigo-600 transition-colors duration-300"
            >
              BookurSpot
            </Link>
          </div>

          <div className="flex items-center space-x-6">
            <button
              className="flex items-center text-black hover:text-gray-600 cursor-pointer space-x-2"
              onClick={openModal}
            >
              <BiSupport size={24} />
              <span>Support</span>
            </button>

            <div className="flex items-center text-black hover:text-gray-600 space-x-2">
              <span>Hi, {username}</span>
              <IoPersonCircleOutline size={36} />
            </div>
          </div>
        </div>
      </nav>

      {/* Modal for Support */}
      <ContactUsModal
        isOpen={isModalOpen}
        closeModal={closeModal}
        subject={subject}
        setSubject={setSubject}
        description={description}
        setDescription={setDescription}
        sendEmail={sendEmail}
      />
    </>
  );
};

export default ClientNavBar;
